import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
// utils
import useAuth from 'src/hooks/useAuth';
import { ChatWindow, ChatSidebar } from 'src/sections/@chats/chat';
import ChatInfoSidebar from 'src/sections/@chats/chat/ChatInfoSidebar';
import { ChatContactSearch } from 'src/components/_chats/chat';
import { getChatsAtendimento, getChatsPendente, getCountsChats, getListaFunil, getListaTags, getPesquisarChats, setChatInfo, setDrawerPesquisas, setMessage } from 'src/redux/slices/chat';
// redux
import { setLimparChatStaff, setMessages } from 'src/redux/slices/staff';
// hooks
import { useDispatch, useSelector } from 'src/redux/store';
//services
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import MenuOptionsNovo from 'src/sections/@dashboard/negocios/MenuOptionsNovo';
import { getConfig } from 'src/redux/slices/global';
import EmptyContentChat from 'src/components/EmptyContentChat';
import { Card } from 'src/@/components/ui/card';

export default function Chat() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { user, cliente } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchFocused, setSearchFocused] = useState(false);
  const { chatInfo, loadingPesquisarChat, mensagensArquivos, mensagensEnviar } = useSelector((state) => state.chat);
  const { config } = useSelector((state) => state.global);
  const [listaClientesCanais, setListaClientesCanais] = useState([]);
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [sidebarLeft, setSidebarLeft] = useState(false);
  const [openInfoSidebar, setOpenInfoSidebar] = useState(true);

  const messagesMergeArquivos = useMemo(() => {
    return (mensagensArquivos || []).concat(mensagensEnviar || []).reverse();
  }, [mensagensArquivos, mensagensEnviar]);




  async function buscarListaClientesCanais() {
    try {
      const response_clientes_canais = await actionListaClientesCanais(cliente._id)
      setListaClientesCanais(response_clientes_canais.data.data);
    } catch (err) {
      console.log(err)
    }
  }

  const handleClickAwaySearch = () => {
    setSearchFocused(false);
    setSearchQuery('');
  };

  const handleSearchFocus = () => {
    setSearchFocused(true);
  };


  const handleChangeSearch = async (event) => {
    try {
      const { value } = event.target;
      setSearchQuery(value);
      dispatch(getPesquisarChats(user.clienteId, value));
      if (value === '') {
        dispatch(setDrawerPesquisas(false))
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
    dispatch(getChatsPendente(user.clienteId, user.id, user.setorId));
    dispatch(getListaFunil(user.clienteId));
    let querys = `?cliente_id=${user.clienteId}`
    dispatch(getListaTags(querys))
    dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
    dispatch(setLimparChatStaff());
    dispatch(getConfig());
    if (cliente.multiSession === 1) {
      buscarListaClientesCanais()
    }

    const handleKeyPress = (event) => {
      // Verifica se a tecla pressionada é a tecla "Esc" (código 27)
      if (event.keyCode === 27) {
        // Chama sua função aqui
        dispatch(setChatInfo(null))
        dispatch(setMessages([]))
      }
    };

    // Adiciona um ouvinte de eventos ao documento para capturar pressionamentos de teclas
    document.addEventListener('keydown', handleKeyPress);

    // Remove o ouvinte de eventos ao desmontar o componente
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };

  }, []);


  // Verificar modo de layout
  const [layoutMode, setLayoutMode] = useState(() => {
    return localStorage.getItem('layoutMode') || 'navbar';
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const newMode = localStorage.getItem('layoutMode') || 'navbar';
      setLayoutMode(newMode);
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('layoutModeChange', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('layoutModeChange', handleStorageChange);
    };
  }, []);

  // mt-14 apenas para mobile E apenas quando navbar está ativo (sidebar já tem seu próprio header)
  const shouldAddMarginTop = layoutMode === 'navbar';

  return (
    <div className="h-full flex bg-neutral-100 dark:bg-[#111214] overflow-hidden">
      <div className="flex-1 flex gap-2 p-1 md:p-3 overflow-hidden">
        {/* Card 1 — Chat list */}
        {(!sidebarLeft && (!isMobile || !chatInfo)) && (
          <Card className="w-full min-w-0 md:w-[400px] md:min-w-[400px] flex-shrink-0 p-0 flex flex-col">
            <div className="flex justify-between items-center py-3 px-3 flex-shrink-0 gap-2">
              <ChatContactSearch
                query={searchQuery}
                onFocus={handleSearchFocus}
                onChange={handleChangeSearch}
                onClickAway={handleClickAwaySearch}
              />
              <MenuOptionsNovo />
            </div>
            <ChatSidebar />
          </Card>
        )}

        {/* Card 2 — Conversation */}
        {(!isMobile || chatInfo) && (
          <Card className="flex-1 relative min-w-0">
            {chatInfo ? (
              <div className="absolute inset-0 flex flex-col">
                <div className="flex-1 flex flex-row min-h-0">
                  <ChatWindow
                    layoutMode="sidebar"
                    sidebarLeft={sidebarLeft}
                    changeOpenSidebarLeft={() => {
                      if (isMobile) {
                        dispatch(setChatInfo(null));
                        dispatch(setMessages([]));
                        setSidebarLeft(false);
                      } else {
                        setSidebarLeft(!sidebarLeft);
                      }
                    }}
                    config={config}
                    chatInfo={chatInfo}
                    hideSidebar
                    onSidebarToggle={() => setOpenInfoSidebar(!openInfoSidebar)}
                  />
                </div>
              </div>
            ) : (
              <EmptyContentChat title="Selecione um chat para começar" />
            )}
          </Card>
        )}

        {/* Card 3 — Chat Info Sidebar */}
        {chatInfo && openInfoSidebar && !isMobile && (
          <Card className="w-[320px] min-w-[320px] flex-shrink-0">
            <ChatInfoSidebar chat={chatInfo} messagesWpp={messagesMergeArquivos} />
          </Card>
        )}
      </div>
    </div>
  );
}
